import { permissionDirective } from "@/utils/permission";

export const registerDirective = {
  install(app) {
    app.directive("permission", permissionDirective);
  },
};
